// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"HighlightsA_TheComp__oYtlp","itemSelling":"HighlightsA_itemSelling__3OpG8"};